module.exports = __webpack_public_path__ + "img/nav_corner.b363ab92.png";